
import {
  UPDATE_COUPON,
  REMOVE_COUPON,
} from '../../GlobalStateContainer'

export const CouponCode = function (state = '', action) {
  switch (action.type) {
    case UPDATE_COUPON:
      return action.couponCode;
    case REMOVE_COUPON:
      return '';
    default: return state;
  }
}


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Coupon/couponReducers.js